import React, { Suspense } from 'react';
import { CircularProgress } from '@material-ui/core';

// Suspense is currently used for lazily loaded components
export const Loading = ({ isLoading = false, children, error }) => (
  <Suspense fallback={<p>Loading...</p>}>{isLoading ? <CircularProgress /> : children}</Suspense>
);
